import React from "react";
import { useSelector } from "react-redux";
const EthniCity = (props) => {
  const [ethniCityCd, setEthniCityCd] = React.useState([]);
  const lang = useSelector((state) => state.webApp.language);
  const ethniCity_En = [
    {
      label: "No, not of Hispanic, Latino/a, or Spanish origin",
      id: "NA",
    },
    {
      label: "Yes, Mexican, Mexican American, Chicano/a",
      id: "MX",
    },
    {
      label: "Yes, Puerto Rican",
      id: "PR",
    },
    {
      label: "Yes, Cuban",
      id: "CUB",
    },
    {
      label: "Yes, another Hispanic, Latino/a, or Spanish origin",
      id: "OTH",
    },
    {
      label: "I choose not to answer.",
      id: "NR",
    },
  ];
  const ethniCity_Es = [
    {
      label: "No, no soy de origen hispano, latino/a o español",
      id: "NA",
    },
    {
      label: "Sí, mexicano, mexicoamericano, chicano/a",
      id: "MX",
    },
    {
      label: "Si puertorriqueña",
      id: "PR",
    },
    {
      label: "Sí, cubano",
      id: "CUB",
    },
    {
      label: "Sí, otro origen hispano, latino/a o español.",
      id: "OTH",
    },
    {
      label: "Decido no responder.",
      id: "NR",
    },
  ];
  React.useEffect(() => {
    if (lang === "en") {
      setEthniCityCd(ethniCity_En);
    } else if (lang === "es") {
      setEthniCityCd(ethniCity_Es);
    }
  }, []);
  return (
    <div class="row pl-5 mobile-ethnicity-padding">
      {ethniCityCd.map((E, index) => (
        <div
          class="col-lg-6 col-md-12 col-sm-12 d-flex flex-row"
          key={`Race${index}`}
        >
          <input
            autoComplete="off"
            spellcheck="false"
           // aria-autocomplete="both"
            aria-haspopup="false"
            type="checkbox"
            class="customCheckbox"
            id={E.id}
            name="ETHNICITY"
            value={E.id}
            checked={
              props.ethnicityRace?.some((item) => item?.piValue === E.id)
                ? true
                : false
            }
            onChange={props.handleRaceAndEthic}
          />
          <label
            // class="custom-control-label"
            for="NA"
          >
            {E.label}
          </label>
        </div>
      ))}
    </div>
  );
};
export default EthniCity;
